import React from 'react'
import { Label, Popup  } from 'semantic-ui-react'

const transparentPixel = 'data:image/gif;base64,R0lGODlhAQABAIAAAAAAAP///yH5BAEAAAAALAAAAAABAAEAAAIBRAA7'

const popupStyle = {
  borderRadius: 0,
  opacity: 0.7,
}

const Badge = ({ icon, text, popup }) => (
  <Popup trigger={
  <Label style={{ color: '#ffe445',  border: '1px solid #ffe445' }}>
    <img src={icon || transparentPixel} alt='' height={20} style={{ marginRight: '0.42857143em' }} />
    {text}
  </Label>
  } content={popup} style={popupStyle}/>
)

export default Badge



// WEBPACK FOOTER //
// ./src/components/Badge.js